import type { NativeStackScreenProps } from "@react-navigation/native-stack";
import { useTranslations } from "@src/packages/i18n";
import type { YouStackParamList } from "../../../types";
import { useYouScreen } from "../YouScreenContext";
import ResearchStudies from "../sections/ResearchStudies";
import YouDetailScreenLayout from "../components/YouDetailScreenLayout";
import { useSmartBack } from "../../../hooks/useSmartBack";

type Props = NativeStackScreenProps<YouStackParamList, "ResearchStudiesDetail">;

export default function ResearchStudiesDetailScreen(_props: Props) {
  const handleBack = useSmartBack({
    fallbackTab: "Profile",
    fallbackScreen: "YouOverview",
  });
  const t = useTranslations();
  const { state, dispatch, researchConsent } = useYouScreen();

  return (
    <YouDetailScreenLayout
      title={t("you.panel_titles.research_studies")}
      onBack={handleBack}
    >
      <ResearchStudies
        studies={state.studies}
        anonymousDataContribution={researchConsent.value}
        anonymousDataContributionLoadFailed={researchConsent.hasLoadError}
        anonymousDataContributionSaveFailed={researchConsent.hasSaveError}
        onRetryAnonymousDataContributionLoad={researchConsent.retryLoad}
        isRetryingAnonymousDataContributionLoad={researchConsent.isRetryingLoad}
        onAnonymousDataContributionChange={(value) =>
          dispatch({ type: "SET_ANONYMOUS_DATA", value })
        }
      />
    </YouDetailScreenLayout>
  );
}
